export default "__VITE_ASSET__5xzgNZ2D__"